import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-5 rounded-2xl bg-gray-50/70 dark:bg-gray-800/40 border border-gray-200/80 dark:border-gray-700/80 space-y-4" }
const _hoisted_2 = { class: "flex items-center gap-2 border-b border-gray-200 dark:border-gray-700 pb-2" }
const _hoisted_3 = { class: "grid grid-cols-1 sm:grid-cols-3 gap-4" }
const _hoisted_4 = {
  key: 0,
  class: "mt-1 text-xs text-red-500 font-medium"
}
const _hoisted_5 = {
  key: 0,
  class: "mt-1 text-xs text-red-500 font-medium"
}
const _hoisted_6 = { class: "grid grid-cols-1 sm:grid-cols-3 gap-4" }
const _hoisted_7 = { class: "p-5 rounded-2xl bg-gray-50/70 dark:bg-gray-800/40 border border-gray-200/80 dark:border-gray-700/80 space-y-4" }
const _hoisted_8 = { class: "flex items-center gap-2 border-b border-gray-200 dark:border-gray-700 pb-2" }
const _hoisted_9 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4" }
const _hoisted_10 = {
  key: 0,
  class: "mt-1 text-xs text-red-500 font-medium"
}
const _hoisted_11 = { class: "grid grid-cols-1 sm:grid-cols-3 md:grid-cols-4 gap-4 pt-1" }
const _hoisted_12 = { class: "sm:col-span-3 md:col-span-4" }
const _hoisted_13 = { class: "sm:col-span-2" }
const _hoisted_14 = { class: "p-5 rounded-2xl bg-gray-50/70 dark:bg-gray-800/40 border border-gray-200/80 dark:border-gray-700/80 space-y-4" }
const _hoisted_15 = { class: "flex items-center gap-2 border-b border-gray-200 dark:border-gray-700 pb-2" }
const _hoisted_16 = { class: "grid grid-cols-1 sm:grid-cols-3 gap-4" }
const _hoisted_17 = { class: "grid grid-cols-1 sm:grid-cols-2 gap-4 pt-1" }
const _hoisted_18 = { class: "p-5 rounded-2xl bg-gray-50/70 dark:bg-gray-800/40 border border-gray-200/80 dark:border-gray-700/80 space-y-4" }
const _hoisted_19 = { class: "flex items-center gap-2 border-b border-gray-200 dark:border-gray-700 pb-2" }
const _hoisted_20 = { class: "grid grid-cols-1 sm:grid-cols-3 gap-4" }
const _hoisted_21 = { class: "p-5 rounded-2xl bg-gray-50/70 dark:bg-gray-800/40 border border-gray-200/80 dark:border-gray-700/80 space-y-4" }
const _hoisted_22 = { class: "flex items-center justify-between border-b border-gray-200 dark:border-gray-700 pb-2" }
const _hoisted_23 = { class: "flex items-center gap-2" }
const _hoisted_24 = { class: "relative inline-flex items-center cursor-pointer" }
const _hoisted_25 = {
  key: 0,
  class: "grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2 items-start"
}
const _hoisted_26 = ["required"]
const _hoisted_27 = {
  key: 0,
  class: "mt-1 text-xs text-red-500 font-medium"
}
const _hoisted_28 = ["required"]
const _hoisted_29 = {
  key: 0,
  class: "mt-1 text-xs text-red-500 font-medium"
}
const _hoisted_30 = { class: "flex items-center justify-end gap-3 w-full" }

import { ref, watch, reactive } from 'vue'
import BaseModal from '@/components/common/BaseModal.vue'
import BaseButton from '@/components/common/BaseButton.vue'
import { employeeService } from '@/services/user'
import { useToastService } from '@/services/toast'
import type { employee } from '@/types/employee'
import {
  UserPen,
  User,
  MapPin,
  Briefcase,
  AlertTriangle,
  Key,
  Save,
} from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'EditStaffProfile',
  props: {
    isVisible: { type: Boolean },
    employee: {}
  },
  emits: ["close", "success"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const toast = useToastService()
const isSubmitting = ref(false)
const shouldUpdatePassword = ref(false)
const errors = ref<Record<string, string[]>>({})

const formData = reactive({
  first_name: '',
  middle_name: '',
  last_name: '',
  date_of_birth: '',
  gender: '',
  ssn_last_four: '',
  email: '',
  phone_number: '',
  street_address: '',
  city: '',
  state: '',
  zip_code: '',
  position: '',
  department: '',
  work_state: '',
  service_population: '',
  hire_date: '',
  emergency_contact_name: '',
  emergency_contact_relation: '',
  emergency_contact_phone: '',
  password: '',
  password_confirmation: '',
})

// Initialize or reset form data from prop
watch(
  [() => props.employee, () => props.isVisible],
  ([newEmployee, isVisible]) => {
    if (newEmployee && isVisible) {
      formData.first_name = newEmployee.first_name || ''
      formData.middle_name = newEmployee.middle_name || ''
      formData.last_name = newEmployee.last_name || ''
      formData.date_of_birth = newEmployee.date_of_birth || ''
      formData.gender = newEmployee.gender || ''
      formData.ssn_last_four = newEmployee.ssn_last_four || ''
      formData.email = newEmployee.email || ''
      formData.phone_number = newEmployee.phone_number || ''
      formData.street_address = newEmployee.street_address || ''
      formData.city = newEmployee.city || ''
      formData.state = newEmployee.state || ''
      formData.zip_code = newEmployee.zip_code || ''
      formData.position = newEmployee.position || ''
      formData.department = newEmployee.department || ''
      formData.work_state = newEmployee.work_state || ''
      formData.service_population = newEmployee.service_population || ''
      formData.hire_date = newEmployee.hire_date || ''
      formData.emergency_contact_name = newEmployee.emergency_contact_name || ''
      formData.emergency_contact_relation = newEmployee.emergency_contact_relation || ''
      formData.emergency_contact_phone = newEmployee.emergency_contact_phone || ''
      formData.password = ''
      formData.password_confirmation = ''
      shouldUpdatePassword.value = false
      errors.value = {}
    }
  },
  { immediate: true }
)

const generatePassword = () => {
  const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789!@#$'
  let pwd = ''
  for (let i = 0; i < 12; i++) {
    pwd += chars.charAt(Math.floor(Math.random() * chars.length))
  }
  formData.password = pwd
  formData.password_confirmation = pwd
  toast.info('Generated password copied into fields')
}

const handleSubmit = async () => {
  if (!props.employee) return

  errors.value = {}

  if (shouldUpdatePassword.value) {
    if (!formData.password) {
      errors.value.password = ['New password is required when reset password is enabled.']
      return
    }

    if (!formData.password_confirmation) {
      errors.value.password_confirmation = ['Password confirmation is required.']
      return
    }

    const hasPasswordSymbol = /[!@#$%^&*(),.?":{}|<>_~\-+=]/.test(formData.password)

    if (formData.password.length < 8 || !hasPasswordSymbol) {
      errors.value.password = ['Password must be at least 8 characters long with at least one symbol.']
      return
    }

    if (formData.password !== formData.password_confirmation) {
      errors.value.password_confirmation = ['Password confirmation does not match.']
      return
    }
  }

  isSubmitting.value = true

  try {
    const payload: any = {
      first_name: formData.first_name,
      middle_name: formData.middle_name || null,
      last_name: formData.last_name,
      date_of_birth: formData.date_of_birth || null,
      gender: formData.gender || null,
      ssn_last_four: formData.ssn_last_four || null,
      email: formData.email,
      phone_number: formData.phone_number || null,
      street_address: formData.street_address || null,
      city: formData.city || null,
      state: formData.state || null,
      zip_code: formData.zip_code || null,
      position: formData.position || null,
      department: formData.department || null,
      work_state: formData.work_state || null,
      service_population: formData.service_population || null,
      hire_date: formData.hire_date || null,
      emergency_contact_name: formData.emergency_contact_name || null,
      emergency_contact_relation: formData.emergency_contact_relation || null,
      emergency_contact_phone: formData.emergency_contact_phone || null,
    }

    if (shouldUpdatePassword.value && formData.password) {
      payload.password = formData.password
      payload.password_confirmation = formData.password_confirmation
    }

    const updated = await employeeService.updateEmployee(props.employee.user_details_id, payload)
    toast.success('Staff profile updated successfully')
    emit('success', updated)
    emit('close')
  } catch (err: any) {
    if (err?.response?.status === 422 && err.response.data?.errors) {
      errors.value = err.response.data.errors
      toast.error(err.response.data.message || 'Please check form errors.')
    } else {
      toast.error('Failed to update staff profile. Please try again.')
    }
  } finally {
    isSubmitting.value = false
  }
}

const closeModal = () => {
  if (!isSubmitting.value) {
    emit('close')
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseModal, {
    "is-visible": _ctx.isVisible,
    title: "Edit Staff Profile",
    subtitle: _ctx.employee ? `Update details for ${_ctx.employee.first_name} ${_ctx.employee.last_name}` : 'Update staff information',
    icon: _unref(UserPen),
    size: "3xl",
    type: "default",
    "show-footer": true,
    onClose: closeModal
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_30, [
        _createVNode(BaseButton, {
          text: "Cancel",
          variant: "outline",
          size: "md",
          disabled: isSubmitting.value,
          onClick: closeModal
        }, null, 8, ["disabled"]),
        _createVNode(BaseButton, {
          text: "Save Changes",
          variant: "primary",
          size: "md",
          loading: isSubmitting.value,
          icon: _unref(Save),
          onClick: handleSubmit
        }, null, 8, ["loading", "icon"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _withModifiers(handleSubmit, ["prevent"]),
        id: "editStaffProfileForm",
        class: "space-y-6"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(User), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
            _cache[23] || (_cache[23] = _createElementVNode("h3", { class: "text-sm font-bold uppercase tracking-wider text-gray-800 dark:text-gray-200" }, " Personal Information ", -1))
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _cache[24] || (_cache[24] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5" }, [
                _createTextVNode(" First Name "),
                _createElementVNode("span", { class: "text-red-500" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.first_name) = $event)),
                type: "text",
                class: _normalizeClass(["w-full px-3.5 py-2.5 text-sm rounded-xl border bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition focus:ring-2 focus:ring-secondary focus:border-secondary outline-none shadow-sm", errors.value.first_name ? 'border-red-500' : 'border-gray-300 dark:border-gray-600']),
                placeholder: "First name",
                required: ""
              }, null, 2), [
                [_vModelText, formData.first_name]
              ]),
              (errors.value.first_name)
                ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(errors.value.first_name[0]), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _cache[25] || (_cache[25] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5" }, " Middle Name ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.middle_name) = $event)),
                type: "text",
                class: "w-full px-3.5 py-2.5 text-sm rounded-xl border bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition focus:ring-2 focus:ring-secondary focus:border-secondary outline-none shadow-sm",
                placeholder: "Middle name (optional)"
              }, null, 512), [
                [_vModelText, formData.middle_name]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[26] || (_cache[26] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5" }, [
                _createTextVNode(" Last Name "),
                _createElementVNode("span", { class: "text-red-500" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.last_name) = $event)),
                type: "text",
                class: _normalizeClass(["w-full px-3.5 py-2.5 text-sm rounded-xl border bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition focus:ring-2 focus:ring-secondary focus:border-secondary outline-none shadow-sm", errors.value.last_name ? 'border-red-500' : 'border-gray-300 dark:border-gray-600']),
                placeholder: "Last name",
                required: ""
              }, null, 2), [
                [_vModelText, formData.last_name]
              ]),
              (errors.value.last_name)
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(errors.value.last_name[0]), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _cache[27] || (_cache[27] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5" }, " Date of Birth ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.date_of_birth) = $event)),
                type: "date",
                class: "w-full px-3.5 py-2.5 text-sm rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition focus:ring-2 focus:ring-secondary focus:border-secondary outline-none shadow-sm"
              }, null, 512), [
                [_vModelText, formData.date_of_birth]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[29] || (_cache[29] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5" }, " Gender ", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.gender) = $event)),
                class: "w-full px-3.5 py-2.5 text-sm rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition focus:ring-2 focus:ring-secondary focus:border-secondary outline-none shadow-sm"
              }, [...(_cache[28] || (_cache[28] = [
                _createElementVNode("option", { value: "" }, "Select Gender", -1),
                _createElementVNode("option", { value: "Male" }, "Male", -1),
                _createElementVNode("option", { value: "Female" }, "Female", -1),
                _createElementVNode("option", { value: "Non-Binary" }, "Non-Binary", -1),
                _createElementVNode("option", { value: "Prefer not to say" }, "Prefer not to say", -1)
              ]))], 512), [
                [_vModelSelect, formData.gender]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[30] || (_cache[30] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5" }, " SSN (Last 4 digits) ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.ssn_last_four) = $event)),
                type: "text",
                maxlength: "4",
                pattern: "\\d{4}",
                class: "w-full px-3.5 py-2.5 text-sm rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition focus:ring-2 focus:ring-secondary focus:border-secondary outline-none shadow-sm",
                placeholder: "e.g. 1234"
              }, null, 512), [
                [_vModelText, formData.ssn_last_four]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_unref(MapPin), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
            _cache[31] || (_cache[31] = _createElementVNode("h3", { class: "text-sm font-bold uppercase tracking-wider text-gray-800 dark:text-gray-200" }, " Contact & Address Information ", -1))
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, [
              _cache[32] || (_cache[32] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5" }, [
                _createTextVNode(" Email Address "),
                _createElementVNode("span", { class: "text-red-500" }, "*")
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.email) = $event)),
                type: "email",
                class: _normalizeClass(["w-full px-3.5 py-2.5 text-sm rounded-xl border bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition focus:ring-2 focus:ring-secondary focus:border-secondary outline-none shadow-sm", errors.value.email ? 'border-red-500' : 'border-gray-300 dark:border-gray-600']),
                placeholder: "staff@jeducare.com",
                required: ""
              }, null, 2), [
                [_vModelText, formData.email]
              ]),
              (errors.value.email)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(errors.value.email[0]), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _cache[33] || (_cache[33] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5" }, " Phone Number ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.phone_number) = $event)),
                type: "tel",
                class: "w-full px-3.5 py-2.5 text-sm rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition focus:ring-2 focus:ring-secondary focus:border-secondary outline-none shadow-sm",
                placeholder: "(555) 000-0000"
              }, null, 512), [
                [_vModelText, formData.phone_number]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[34] || (_cache[34] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5" }, " Street Address ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.street_address) = $event)),
                type: "text",
                class: "w-full px-3.5 py-2.5 text-sm rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition focus:ring-2 focus:ring-secondary focus:border-secondary outline-none shadow-sm",
                placeholder: "123 Main St, Apt 4B"
              }, null, 512), [
                [_vModelText, formData.street_address]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[35] || (_cache[35] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5" }, " City ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.city) = $event)),
                type: "text",
                class: "w-full px-3.5 py-2.5 text-sm rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition focus:ring-2 focus:ring-secondary focus:border-secondary outline-none shadow-sm",
                placeholder: "City"
              }, null, 512), [
                [_vModelText, formData.city]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[36] || (_cache[36] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5" }, " State ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.state) = $event)),
                type: "text",
                class: "w-full px-3.5 py-2.5 text-sm rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition focus:ring-2 focus:ring-secondary focus:border-secondary outline-none shadow-sm",
                placeholder: "e.g. MD"
              }, null, 512), [
                [_vModelText, formData.state]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[37] || (_cache[37] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5" }, " Zip Code ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.zip_code) = $event)),
                type: "text",
                class: "w-full px-3.5 py-2.5 text-sm rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition focus:ring-2 focus:ring-secondary focus:border-secondary outline-none shadow-sm",
                placeholder: "Zip Code"
              }, null, 512), [
                [_vModelText, formData.zip_code]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_unref(Briefcase), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
            _cache[38] || (_cache[38] = _createElementVNode("h3", { class: "text-sm font-bold uppercase tracking-wider text-gray-800 dark:text-gray-200" }, " Employment Details ", -1))
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", null, [
              _cache[39] || (_cache[39] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5" }, " Position / Job Title ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.position) = $event)),
                type: "text",
                class: "w-full px-3.5 py-2.5 text-sm rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition focus:ring-2 focus:ring-secondary focus:border-secondary outline-none shadow-sm",
                placeholder: "e.g. Direct Support Professional"
              }, null, 512), [
                [_vModelText, formData.position]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[40] || (_cache[40] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5" }, " Department ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.department) = $event)),
                type: "text",
                class: "w-full px-3.5 py-2.5 text-sm rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition focus:ring-2 focus:ring-secondary focus:border-secondary outline-none shadow-sm",
                placeholder: "e.g. Care Services"
              }, null, 512), [
                [_vModelText, formData.department]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[41] || (_cache[41] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5" }, " Date of Hire ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.hire_date) = $event)),
                type: "date",
                class: "w-full px-3.5 py-2.5 text-sm rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition focus:ring-2 focus:ring-secondary focus:border-secondary outline-none shadow-sm"
              }, null, 512), [
                [_vModelText, formData.hire_date]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", null, [
              _cache[43] || (_cache[43] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5" }, " Work State / Jurisdiction ", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.work_state) = $event)),
                class: "w-full px-3.5 py-2.5 text-sm rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition focus:ring-2 focus:ring-secondary focus:border-secondary outline-none shadow-sm"
              }, [...(_cache[42] || (_cache[42] = [
                _createElementVNode("option", { value: "" }, "Select Work State", -1),
                _createElementVNode("option", { value: "Maryland" }, "Maryland", -1),
                _createElementVNode("option", { value: "DC" }, "DC", -1),
                _createElementVNode("option", { value: "Both" }, "Both (Maryland & DC)", -1)
              ]))], 512), [
                [_vModelSelect, formData.work_state]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[45] || (_cache[45] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5" }, " Client Group / Service Population ", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.service_population) = $event)),
                class: "w-full px-3.5 py-2.5 text-sm rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition focus:ring-2 focus:ring-secondary focus:border-secondary outline-none shadow-sm"
              }, [...(_cache[44] || (_cache[44] = [
                _createElementVNode("option", { value: "" }, "Select Client Group", -1),
                _createElementVNode("option", { value: "Adults" }, "Adults", -1),
                _createElementVNode("option", { value: "Kids" }, "Kids", -1),
                _createElementVNode("option", { value: "Both" }, "Both (Adults & Kids)", -1)
              ]))], 512), [
                [_vModelSelect, formData.service_population]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_unref(AlertTriangle), { class: "w-4 h-4 text-amber-500" }),
            _cache[46] || (_cache[46] = _createElementVNode("h3", { class: "text-sm font-bold uppercase tracking-wider text-gray-800 dark:text-gray-200" }, " Emergency Contact ", -1))
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", null, [
              _cache[47] || (_cache[47] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5" }, " Emergency Contact Name ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.emergency_contact_name) = $event)),
                type: "text",
                class: "w-full px-3.5 py-2.5 text-sm rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition focus:ring-2 focus:ring-secondary focus:border-secondary outline-none shadow-sm",
                placeholder: "Full name"
              }, null, 512), [
                [_vModelText, formData.emergency_contact_name]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[48] || (_cache[48] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5" }, " Relationship ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.emergency_contact_relation) = $event)),
                type: "text",
                class: "w-full px-3.5 py-2.5 text-sm rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition focus:ring-2 focus:ring-secondary focus:border-secondary outline-none shadow-sm",
                placeholder: "e.g. Spouse, Parent, Sibling"
              }, null, 512), [
                [_vModelText, formData.emergency_contact_relation]
              ])
            ]),
            _createElementVNode("div", null, [
              _cache[49] || (_cache[49] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300 mb-1.5" }, " Emergency Phone Number ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formData.emergency_contact_phone) = $event)),
                type: "tel",
                class: "w-full px-3.5 py-2.5 text-sm rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition focus:ring-2 focus:ring-secondary focus:border-secondary outline-none shadow-sm",
                placeholder: "(555) 000-0000"
              }, null, 512), [
                [_vModelText, formData.emergency_contact_phone]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_unref(Key), { class: "w-4 h-4 text-secondary dark:text-secondary-dark-text" }),
              _cache[50] || (_cache[50] = _createElementVNode("h3", { class: "text-sm font-bold uppercase tracking-wider text-gray-800 dark:text-gray-200" }, " Reset Password (Optional) ", -1))
            ]),
            _createElementVNode("label", _hoisted_24, [
              _withDirectives(_createElementVNode("input", {
                type: "checkbox",
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((shouldUpdatePassword).value = $event)),
                class: "sr-only peer"
              }, null, 512), [
                [_vModelCheckbox, shouldUpdatePassword.value]
              ]),
              _cache[51] || (_cache[51] = _createElementVNode("div", { class: "w-10 h-5 bg-gray-200 peer-focus:outline-none rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-secondary" }, null, -1)),
              _cache[52] || (_cache[52] = _createElementVNode("span", { class: "ml-2 text-xs font-medium text-gray-600 dark:text-gray-300" }, "Enable", -1))
            ])
          ]),
          (shouldUpdatePassword.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", { class: "flex items-center justify-between h-5 mb-1.5" }, [
                    _cache[53] || (_cache[53] = _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300" }, [
                      _createTextVNode(" New Password "),
                      _createElementVNode("span", { class: "text-red-500" }, "*")
                    ], -1)),
                    _createElementVNode("button", {
                      type: "button",
                      onClick: generatePassword,
                      class: "text-[11px] text-secondary dark:text-secondary-dark-text hover:underline font-semibold cursor-pointer"
                    }, " Generate ")
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formData.password) = $event)),
                    type: "password",
                    class: _normalizeClass(["w-full px-3.5 py-2.5 text-sm rounded-xl border bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition focus:ring-2 focus:ring-secondary focus:border-secondary outline-none shadow-sm", errors.value.password ? 'border-red-500' : 'border-gray-300 dark:border-gray-600']),
                    placeholder: "Minimum 8 characters, 1 symbol",
                    minlength: "8",
                    required: shouldUpdatePassword.value
                  }, null, 10, _hoisted_26), [
                    [_vModelText, formData.password]
                  ]),
                  (errors.value.password)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(errors.value.password[0]), 1))
                    : _createCommentVNode("", true),
                  _cache[54] || (_cache[54] = _createElementVNode("p", { class: "mt-1 text-xs text-gray-500 dark:text-gray-400" }, " Password must be at least 8 characters long with at least one symbol ", -1))
                ]),
                _createElementVNode("div", null, [
                  _cache[55] || (_cache[55] = _createElementVNode("div", { class: "flex items-center justify-between h-5 mb-1.5" }, [
                    _createElementVNode("label", { class: "block text-xs font-semibold text-gray-700 dark:text-gray-300" }, [
                      _createTextVNode(" Confirm New Password "),
                      _createElementVNode("span", { class: "text-red-500" }, "*")
                    ])
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((formData.password_confirmation) = $event)),
                    type: "text",
                    class: _normalizeClass(["w-full px-3.5 py-2.5 text-sm rounded-xl border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white transition focus:ring-2 focus:ring-secondary focus:border-secondary outline-none shadow-sm", errors.value.password_confirmation ? 'border-red-500' : 'border-gray-300 dark:border-gray-600']),
                    placeholder: "Confirm password",
                    required: shouldUpdatePassword.value
                  }, null, 10, _hoisted_28), [
                    [_vModelText, formData.password_confirmation]
                  ]),
                  (errors.value.password_confirmation)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(errors.value.password_confirmation[0]), 1))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["is-visible", "subtitle", "icon"]))
}
}

})